/**
 * Shared helpers for payment account selection in power reporting modals.
 * Used by SubmitReportModal and BatchPaymentModal.
 */

export const ACCOUNT_TYPE_LABELS = {
  C: 'Checking',
  S: 'Savings',
  Checking: 'Checking',
  Savings: 'Savings',
};

/**
 * Format an account for display in a dropdown option.
 * Example: "My Account (Checking) - ****1234 [Personal]"
 * @param {Object} account - Payment account object from getPaymentAccounts
 * @param {number|null} currentUserId - Current user's portalUserId
 * @returns {string}
 */
export const formatAccountOption = (account, currentUserId) => {
  const name = account.nickName || account.nameOnAccount || 'Unnamed Account';
  const type = ACCOUNT_TYPE_LABELS[account.accountType] || account.accountType || '';
  const masked = account.maskedAccountNumber || '';
  const ownership = !account.portalUserId
    ? 'Shared'
    : account.portalUserId === currentUserId
      ? 'Personal'
      : 'Personal';

  const parts = [name];
  if (type) parts[0] += ` (${type})`;
  if (masked) parts.push(masked);
  parts.push(`[${ownership}]`);

  return parts.join(' - ');
};

/**
 * Find the default account for a given payment type (NET or BUF).
 * Matches accounts where defaultPaymentType is the given type or "BOTH".
 * Falls back to the first account in the list.
 * @param {Array} accounts - Active payment accounts
 * @param {'NET'|'BUF'} paymentType - The payment type to find a default for
 * @returns {Object|null} The default account, or first account, or null
 */
export const getDefaultAccount = (accounts, paymentType) => {
  if (!accounts || accounts.length === 0) return null;

  const defaultMatch = accounts.find(
    (a) =>
      a.defaultPaymentType &&
      (a.defaultPaymentType.toUpperCase() === paymentType.toUpperCase() ||
        a.defaultPaymentType.toUpperCase() === 'BOTH')
  );

  return defaultMatch || accounts[0];
};
